import React from 'react';
import styled from 'styled-components';
import { Span, mediaQueries, spacing, fonts, fontSizes, colors } from '../components/Styling';

const CategoriesMenu = styled.div`
  -webkit-overflow-scrolling: touch;
  display: inline-flex;
  flex-wrap: nowrap;
  margin: ${spacing[4]} auto;
  overflow: scroll;
  text-transform: capitalize;
  width: 100%;
  ${mediaQueries.medium`
  flex-wrap: wrap;
    margin: ${spacing[5]} auto;
    width: auto;
  `};
`;

const Category = styled.span`
  background-color: ${props => props.category === props.currentCategory ? colors.black : 'white'};
  border: 2px solid ${props => props.category === props.currentCategory ? colors.black : 'DARKGREY'};
  color: ${props => props.category === props.currentCategory ? 'white' : 'DARKGREY'};
  cursor: pointer;
  flex: 0 1 auto;
  font-family: ${fonts.sans};
  font-size: ${fontSizes[1]};
  margin-bottom: ${spacing[3]};
  padding: 0.5rem 1rem;
  transition: color 0.2s, background-color 0.2s, border-color 0.2s, z-index 0, 0.2s;
  white-space: nowrap;
  z-index: ${props => props.category === props.currentCategory ? 0 : 'initial'};

  &:not(:first-child) {
    margin-left: -2px;
  }

  ${mediaQueries.medium`
    margin-right: ${spacing[3]};
    font-size: ${fontSizes[2]};
    margin-left: 0 !important;
  `};

  &:hover {
    color: white;
    background-color: ${props => props.category === props.currentCategory ? colors.black : 'DARKGREY'};
  }
`;

class GalleryFilter extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(hasValue) {
    this.props.handleClick(hasValue);
  }

  render() {
    return (
      <div>
        <CategoriesMenu>
          {['all'].concat(this.props.categories.sort()).map(category => {
            return (
              <Category
                currentCategory={this.props.currentCategory}
                category={category}
                key={category}
                onClick={() => this.handleClick(category)}
              >
                {category}
              </Category>
            );
          })}
        </CategoriesMenu>
      </div>
    );
  }
}

export default GalleryFilter;



// WEBPACK FOOTER //
// ./src/components/GalleryFilter.js